<template>
  <nav v-bind:class="['nav', isSticky ? 'nav-sticky' : '']">
    <div class="container">
      <a aria-label="Početna" href="/">
        <img src="../../assets/logo.png" class="logo" alt="Početna">
      </a>
      <button class="hamburger" name="Menu" v-on:click="isMenuVisible = !isMenuVisible; toggleBodyOverflow()">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>
      <ul v-bind:class="['menu', isMenuVisible ? 'menu-visible' : '']">
        <div class="container">
          <li>
            <a v-on:click="isMenuVisible = !isMenuVisible; isAutoScroll = true; toggleBodyOverflow()" v-scroll-to="{ el: '#conference', offset: -100, duration: 700 }">Konferencija</a>
          </li>
          <li>
            <a v-on:click="isMenuVisible = !isMenuVisible; isAutoScroll = true; toggleBodyOverflow()" v-scroll-to="{ el: '#schedule', offset: -100 }">Raspored</a>
          </li>
          <li>
            <a v-on:click="isMenuVisible = !isMenuVisible; isAutoScroll = true; toggleBodyOverflow()" v-scroll-to="{ el: '#sponsors', offset: -100, duration: 1000 }">Sponzori</a>
          </li>
          <li>
            <a v-on:click="isMenuVisible = !isMenuVisible; isAutoScroll = true; toggleBodyOverflow()" v-scroll-to="{ el: '#contact', offset: -100, duration: 1500 }">Kontakt</a>
          </li>
          <li>
            <template v-if="!isLoggedIn">
              <button class="button" v-on:click="$emit('showLoginModal'); isMenuVisible = !isMenuVisible; toggleBodyOverflow()">PRIJAVA</button>
            </template>
            <template v-else>
              <button class="button" v-on:click="routeToApp(); isMenuVisible = !isMenuVisible; toggleBodyOverflow()">APLIKACIJA</button>
            </template>
          </li>
          <li>
            <ul>
              <li>
                <a aria-label="Link na facebook" href="https://www.facebook.com/dumpdays/" target="_blank" rel="noreferrer">
                  <img src="../../assets/social/facebook.svg" alt="Facebook">
                </a>
              </li>
              <li>
                <a aria-label="Link na youtube" href="https://www.youtube.com/channel/UC7PMtpZobjWu84C-x_nRW5w" target="_blank" rel="noreferrer">
                  <img src="../../assets/social/youtube.svg" alt="Youtube">
                </a>
              </li>
              <li>
                <a aria-label="Link na instagram" href="https://www.instagram.com/dump_days/" target="_blank" rel="noreferrer">
                  <img src="../../assets/social/instagram.svg" alt="Instagran">
                </a>
              </li>
            </ul>
          </li>
        </div>
      </ul>
    </div>
  </nav>
</template>

<script>
import throttle from 'lodash.throttle';

export default {
  name: "Navigation",
  data() {
    return {
      isMenuVisible: false,
      isSticky: false,
      isAutoScroll: false
    }
  },
  computed: {
    isLoggedIn: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      return true;
    }
  },
  methods : {
    handleScroll: function() {
      if(this.isAutoScroll || document.getElementsByClassName('container')[0] && window.pageYOffset > 0.4 * document.getElementsByClassName('container')[0].offsetHeight)
      {
        this.isSticky = true;
        this.isAutoScroll = false;
      }
      else
        this.isSticky = false;
    },
    isAdmin: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      if(decoded.roles === 'Administrator')
        return true;
      return false;
    },
    toggleBodyOverflow: function() {
      if(this.isMenuVisible && window.innerWidth < 1024)
        document.body.classList.add('no-scroll');
      else
        document.body.classList.remove('no-scroll');
    },
    routeToApp: function() {
      this.isAdmin() ? this.$router.push('admin') : this.$router.push('app');
    }
  },
  mounted() {
    if(document.getElementsByClassName('container'))
    {
      window.addEventListener('scroll', throttle(this.handleScroll, 300));
      this.handleScroll();
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
a:hover {
  cursor: pointer;
}

ul ul {
  list-style-type: none;
  display: flex;
  width: 150px;
  justify-content: space-between;
  align-items: center;
}

ul ul a {
  width: 25px;
  text-decoration: none;
}

ul ul img {
  max-width: 100%;
}

.container > li:last-of-type {
  padding-bottom: 55px;
}

.nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 25px;
  padding-bottom: 25px;
  z-index: 999;
  transition: 0.3s;
}

.nav.nav-sticky {
  background-color: #1d9b90;
}

.nav > .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  z-index: 3;
  height: 42px;
}

.menu {
  z-index: 2;
  position: fixed;
  list-style-type: none;
  pointer-events: none;
  background-color: #2c373f;
  opacity: 1;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100vh;
  padding-top: 165px;
  display: flex;
  align-items: center;
  transform: translate3d(0, -100vh, 0);
  will-change: transform;
  transition: transform 0.25s ease-in-out;
}

.menu > .container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu li {
  margin-bottom: 45px;
}

.menu a {
  text-decoration: none;
  color: #ffffff;
  font-family: "Fuse V.2 Display";
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.7px;
  line-height: 24px;
}

.menu-visible {
  pointer-events: inherit;
  transform: translate3d(0, 0, 0);
}

.menu-visible .bar:nth-of-type(2) {
  opacity: 0;
}

.menu-visible .bar:first-of-type {
  transform: translate3d(0px, 10px, 0) rotate(45deg);
}

.menu-visible .bar:last-of-type {
  transform: translate3d(0%, -9px, 0) rotate(-45deg);
}

.hamburger {
  outline: transparent;
  z-index: 3;
  background: none;
  border: 0;
  height: 20px;
  width: 27px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.bar {
  background-color: #fff;
  display: block;
  height: 2px;
  width: 27px;
  will-change: transform;
  transition: all 0.25s ease-in-out;
  opacity: 1;
}

@media screen and (min-width: 1024px) {
  .hamburger {
    display: none;
  }

  .nav {
    padding: 20px 0;
  }

  .menu {
    position: relative !important;
    opacity: 1 !important;
    height: auto !important;
    transform: none !important;
    padding-top: 0;
    background-color: transparent !important;
    pointer-events: inherit !important;
  }

  .menu > .container {
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    max-width: 100%;
  }

  .menu li {
    margin-bottom: 0;
    margin-left: 50px;
  }

  .menu a {
    font-size: 16px;
    letter-spacing: -0.56px;
    line-height: 19px;
    font-weight: 600;
  }

  li:last-of-type {
    display: none;
  }
}
</style>